@if (loading()) {
  <app-loading />
} @else if (error()) {
  <app-error-data [title]="error()!" />
} @else if (products().length === 0) {
  <div
    class="flex flex-col items-center justify-center gap-4 rounded-[12px] border border-gray-100 bg-white py-16 shadow-xl">
    <svg class="textBorderStrong" width="64" height="64" viewBox="0 0 24 24" fill="none">
      <path
        d="M20 7L12 3L4 7M20 7L12 11M20 7V17L12 21M12 11L4 7M12 11V21M4 7V17L12 21"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
    <p class="textHelpercolorone text-[14px] font-medium">
      {{ isArabic() ? "هذه الباقة لا تحتوي حالياً على أي أصناف." : "This bundle currently has no products assigned." }}
    </p>
    <a class="bgTabsColor hover:bgHoverPrimaryColor cursor-pointer rounded-lg px-6 py-2 text-sm text-white">
      {{ isArabic() ? "أضف أصناف" : "Add Products" }}
    </a>
  </div>
} @else {
  <div
    class="animate-in fade-in slide-in-from-bottom-2 borderhelpercolortwo overflow-hidden rounded-[12px] border bg-white shadow-xl duration-500">
    <table class="w-full">
      <thead class="borderhelpercolortwo bgBgColor border-b">
        <tr>
          <th class="textHelpercolorone px-4 py-3 text-[13px] font-normal ltr:text-left rtl:text-right">
            {{ isArabic() ? "اسم الصنف" : "Product Name" }}
          </th>
          <th class="textHelpercolorone px-4 py-3 text-[13px] font-normal ltr:text-left rtl:text-right">
            {{ isArabic() ? "رقم الدفعة" : "Batch Number" }}
          </th>
          <th class="textHelpercolorone px-4 py-3 text-[13px] font-normal ltr:text-left rtl:text-right">
            {{ isArabic() ? "تاريخ الانتهاء" : "Expiry Date" }}
          </th>
          <th class="textHelpercolorone px-4 py-3 text-center text-[13px] font-normal">
            {{ isArabic() ? "الكمية" : "Quantity" }}
          </th>
          <th class="textHelpercolorone px-4 py-3 text-center text-[13px] font-normal">
            {{ isArabic() ? "سعر الصيدلية" : "Pharmacy Price" }}
          </th>
          <th class="textHelpercolorone px-4 py-3 text-center text-[13px] font-normal">
            {{ isArabic() ? "الإجمالي الفرعي" : "Subtotal" }}
          </th>
          <th class="w-8 px-4 py-3"></th>
        </tr>
      </thead>

      <tbody class="borderhelpercolortwo divide-y">
        @for (product of products(); track product.productId) {
          <tr class="hover:bgBgColor transition-colors">
            <td class="px-4 py-3 ltr:text-left rtl:text-right">
              <div class="flex flex-col">
                <span class="textTableBodyColor text-[13px] font-semibold">
                  {{ isArabic() ? product.titleAr || product.titleEn : product.titleEn || product.titleAr }}
                </span>
              </div>
            </td>
            <td class="textHelpercolorone px-4 py-3 text-[13px] ltr:text-left rtl:text-right">
              {{ product.batchNumber || "—" }}
            </td>
            <td class="textHelpercolorone px-4 py-3 text-[13px] ltr:text-left rtl:text-right">
              {{ product.expiryDate | date: "dd/MM/yyyy" }}
            </td>
            <td class="textTableBodyColor px-4 py-3 text-center text-[13px] font-medium">
              {{ product.quantity }}
            </td>
            <td class="textTableBodyColor px-4 py-3 text-center text-[13px]">
              {{ product.pharmacyPrice }} {{ isArabic() ? "ج.م" : "EGP" }}
            </td>
            <td class="textTableBodyColor px-4 py-3 text-center text-[13px] font-bold">
              {{ product.subtotal }} {{ isArabic() ? "ج.م" : "EGP" }}
            </td>
          </tr>
        }
      </tbody>
    </table>

    @if (bundleProductsData()) {
      <div class="borderhelpercolortwo border-t px-4 py-4">
        <div class="flex flex-col gap-2 ltr:items-end rtl:items-start">
          <div class="flex items-center gap-4 text-[13px]">
            <span class="textHelpercolorone">
              {{ isArabic() ? "نوع وقيمة الخصم:" : "Discount Type and Value:" }}
            </span>
            <span class="textTableBodyColor font-semibold">
              {{
                bundleProductsData()!.discountType === "PERCENTAGE"
                  ? (isArabic() ? "نسبة مئوية" : "Percentage") + " (" + bundleProductsData()!.discountValue + "%)"
                  : (isArabic() ? "مبلغ ثابت" : "Fixed Amount") +
                    " (" +
                    bundleProductsData()!.discountValue +
                    " " +
                    (isArabic() ? "ج.م" : "EGP") +
                    ")"
              }}
            </span>
          </div>

          <div class="flex items-center gap-4 text-[13px]">
            <span class="textHelpercolorone">
              {{ isArabic() ? "السعر الإجمالي بعد الخصم:" : "Total Price After Discount:" }}
            </span>
            <span class="textHelpercolorone text-[13px] line-through">
              {{ bundleProductsData()!.totalPriceBeforeDiscount }} {{ isArabic() ? "ج.م" : "EGP" }}
            </span>
            <span class="textGreenColor text-[15px] font-bold">
              {{ bundleProductsData()!.totalPriceAfterDiscount }} {{ isArabic() ? "ج.م" : "EGP" }}
            </span>
          </div>
        </div>
      </div>
    }
  </div>
}
